import { render } from "./SimpleModal.vue?vue&type=template&id=77892825&scoped=true&bindings={}"
import script from "./SimpleModal.vue?vue&type=script&lang=ts"
export * from "./SimpleModal.vue?vue&type=script&lang=ts"

import "./SimpleModal.vue?vue&type=style&index=0&id=77892825&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77892825"

export default script